import { render, staticRenderFns } from "./PresenceShow.vue?vue&type=template&id=4fab03a4&scoped=true"
import script from "./PresenceShow.vue?vue&type=script&lang=js"
export * from "./PresenceShow.vue?vue&type=script&lang=js"
import style0 from "./PresenceShow.vue?vue&type=style&index=0&id=4fab03a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab03a4",
  null
  
)

export default component.exports